const getDisplayName = (Component?: any): string => {
  if (Component) {
    return Component.displayName || Component.name || 'Component';
  }

  return 'Component';
};

export { getDisplayName };
